import { render, staticRenderFns } from "./LoaderDialog.vue?vue&type=template&id=7441741f&lang=pug&"
import script from "./LoaderDialog.vue?vue&type=script&lang=ts&"
export * from "./LoaderDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderDialog.vue?vue&type=style&index=0&id=7441741f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports